import api from './api';

export function getOtpCode(data) {
  return api.post(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/creditos/${data.idCredito}/prospeccion/notificacion-otp`, data);
}

export function acceptProspection(data) {
  return api.patch(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/creditos/${data.idCredito}/prospeccion/aceptar`, data);
}

export function getOtpCodeFromDocuments(data) {
  return api.post(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/creditos/${data.idCredito}/firma-documentos/notificacion-otp`, data);
}

export function acceptCodeFromDocuments(data) {
  return api.patch(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/creditos/${data.idCredito}/firma-documentos/aceptar`, data)
}
